// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  margin-top: 7em;
  width: 100%;
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  background: linear-gradient(to right, #4b72bb, #7ebeed);
}
`, "",{"version":3,"sources":["webpack://./app/AppStyle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,uDAAuD;AACzD","sourcesContent":["footer {\n  margin-top: 7em;\n  width: 100%;\n  height: 8rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n  background: linear-gradient(to right, #4b72bb, #7ebeed);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
